import { environment } from "src/environments/environment"

const isEts = location.href.indexOf("/tripview.jsp") > -1 || location.href.indexOf("/master.jsp") > -1;
const baseUrl = isEts ? environment.assetPath : "";

export const ASSETS_PATH_CONST: any = {
  ARROW_LEFT: baseUrl + "assets/icons/left-arrow.svg",
  SEARCH_ICON: baseUrl + "assets/icons/ic-search-icon.svg",
  PASSENGER_ICON: baseUrl + "assets/icons/person.svg",
  DOWN_ARROW: baseUrl + "assets/icons/line-down-arrow.svg",
  UP_ARROW: baseUrl + "assets/icons/line-arrow-up.svg",
  TICK_ICON: baseUrl + "assets/icons/tick-active.svg",
  CANCEL_ICON: baseUrl + "assets/icons/navigation-cancel.svg",
  BUS_ICON:baseUrl + "assets/icons/tour-Bus1.svg",
  CAB_ICON:baseUrl + "assets/icons/cab.svg",
  NO_IN_PROGRESS_TRIPS_FOUND:baseUrl + "/assets/lottie-files/no_trips_found.json",
  IN_PROGRESS_TRIPS_LOADER:baseUrl + "/assets/icons/in_progress_trips_loader.gif",
  MALE_EMP_ICON:baseUrl + "/assets/icons/male-emp.svg",
  FEMALE_EMP_ICON:baseUrl + "/assets/icons/female-emp.svg",
  PAGE_NOT_FOUND:baseUrl + "/assets/lottie-files/page_not_found.json",
  ALERT_ICON:baseUrl + "assets/icons/warning.svg",
  ASSISTANT_ICON:baseUrl + "assets/icons/assistant-logo.svg",
}

